import React, { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

import PropTypes from 'prop-types';

const ChatTitle = props => {
    const { title, placeholder, className, variant = 'body1' } = props;
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const measure = () => setIsTruncated(el.scrollWidth > el.clientWidth);
        measure();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [title]);

    // Wrap unconditionally and gate on the title prop (an empty title renders no tooltip):
    // conditionally wrapping would remount the Typography and detach the ResizeObserver.
    return (
        <Tooltip title={isTruncated && title ? title : ''}>
            <Typography ref={ref} variant={variant} className={className} noWrap>
                {title || placeholder}
            </Typography>
        </Tooltip>
    );
};

ChatTitle.propTypes = {
    title: PropTypes.string,
    placeholder: PropTypes.node,
    className: PropTypes.string,
    variant: PropTypes.string,
};

export default ChatTitle;
